<form #productForm="ngForm">
  <div>
    <h1>
      {{ isEdit ? ('PROJECT.PLANT_SPEC.EDIT_PROD' | anessaTranslation) : ('PROJECT.PLANT_SPEC.ADD_PROD' | anessaTranslation) }}
    </h1>
    <div class="col-2" style="margin: auto;">
      <div
        (mouseenter)="showClearPickedGenerated = true"
        (mouseleave)="showClearPickedGenerated = false"
        class="edit-inline-row form-field-container">
        <mat-form-field floatLabel="never">
          <mat-select
            id="edit-product-type_select"
            [(ngModel)]="pickedGenerated"
            name="productPicker"
            required
            (selectionChange)="setName()"
            placeholder="{{'PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation}}">
            <ng-container *ngFor="let opt of productOptions">
              <mat-option [value]="opt"
                          [disabled]="!allowProduct(opt.productType)"
                          [matTooltip]="!allowProduct(opt.productType) ? getDisableMessage(opt.productType) : null"
              >{{opt.name | anessaTranslation: trigger}}</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
        <p
          *ngIf="pickedGenerated && showClearPickedGenerated"
          class="form-field-clear"
          (click)="pickedGenerated = null">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
      </div>
    </div>
  </div>

  <div class="edit-col">
    <div
      (mouseenter)="showClearName = true"
      (mouseleave)="showClearName = false"
      class="edit-inline-row form-field-container">
      <mat-form-field>
        <mat-label>{{'PROJECT.PLANT_SPEC.NAME' | anessaTranslation}}</mat-label>
        <input
          id="edit-product-name_input"
          matInput
          type="text"
          name="name"
          [(ngModel)]="model.name"
          required
          (ngModelChange)="validateName()">
        <mat-error *ngIf="productForm.controls['name'] && productForm.controls['name'].hasError('incorrect-input')">
          {{'PROJECT.COMMON.DOT_ERROR' | anessaTranslation: trigger}}
        </mat-error>
      </mat-form-field>
      <p
        *ngIf="model.name && showClearName"
        class="form-field-clear"
        (click)="clearInput('name')">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
    </div>
  </div>

  <div class="edit-col">
    <div
      (mouseenter)="showClearDesc = true"
      (mouseleave)="showClearDesc = false"
      class="edit-inline-row form-field-container">
    <mat-form-field>
      <mat-label>{{'PROJECT.PLANT_SPEC.DESC' | anessaTranslation}}</mat-label>
      <input
        id="edit-product-description_input"
        matInput
        type="text"
        name="description"
        [(ngModel)]="model.description"
      >
    </mat-form-field>
      <p
        *ngIf="model.description && showClearDesc"
        class="form-field-clear"
        (click)="clearInput('description')">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
    </div>
  </div>

  <div *ngIf="internalUseProduct()">
    <div class="edit-col">
      <h3>{{ 'PROJECT.PLANT_SPEC.INTERNAL_DEMAND' | anessaTranslation }}
        <mat-icon
          matTooltip="{{ 'PROJECT.PLANT_SPEC.ID_TOOLTIP' | anessaTranslation }}">
          help
        </mat-icon>
      </h3>
      <app-unit-value
        [units]="getUnitString()"
        [name]="'internalDemand'"
        [(ngModel)]="model.internalDemand"
        [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation)"
        [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation)"
      ></app-unit-value>
    </div>
  </div>

  <div class="button-row">
    <button id="edit-product-save_button"
            type="button"
            mat-button
            class="mat-mdc-button btn-listadd btn-green"
            [disabled]="!productForm.form.valid"
            (click)="onSave()"
            anessaTranslation="PROJECT.PLANT_SPEC.SAVE_PROD">
    </button>
    <button id="edit-product-cancel_button"
            type="button"
            mat-button
            class="mat-mdc-button btn-listadd btn-red"
            (click)="onCancel()"
            anessaTranslation="PROJECT.COMMON.CANCEL">
    </button>
  </div>
</form>
